export const extractDateFromFileName = (fileName: string): string => {
  if (!fileName || fileName === "--") {
    return "--";
  }

  try {
    // Split by underscore and get the 4th element (index 3)
    const parts = fileName.split("_");

    if (parts.length >= 4) {
      const timestampPart = parts[3]; // YYYYMMDDhhmm or YYYYMMDD

      // Check if it's 12 digits (YYYYMMDDhhmm format)
      if (/^\d{12}/.test(timestampPart)) {
        return timestampPart.substring(0, 8); // Extract first 8 digits (YYYYMMDD)
      }

      // Check if it's 8 digits (YYYYMMDD format)
      if (/^\d{8}$/.test(timestampPart)) {
        return timestampPart;
      }
    }

    return "--";
  } catch (error) {
    console.error("Error extracting date from filename:", error);
    return "--";
  }
};

export const extractFormattedDateFromFileName = (fileName: string): string => {
  const dateString = extractDateFromFileName(fileName);

  if (dateString === "--") {
    return "--";
  }

  try {
    // Parse YYYYMMDD into YYYY-MM-DD
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);

    return `${month}/${day}/${year}`;
  } catch (error) {
    console.error("Error formatting date from filename:", error);
    return "--";
  }
};

export const extractBatchFromFileName = (fileName: string): string => {
  if (!fileName || fileName === "--") {
    return "--";
  }

  try {
    // Split by underscore and get the 4th element onwards
    const parts = fileName.split("_");

    if (parts.length >= 4) {
      const timestampPart = parts[3]; // Could be YYYYMMDDhhmm.csv or YYYYMMDD

      // Check if it's 12 digits (YYYYMMDDhhmm format) - combined date and time
      if (/^\d{12}/.test(timestampPart)) {
        const datePart = timestampPart.substring(0, 8); // YYYYMMDD
        const timePart = timestampPart.substring(8, 12); // hhmm
        return `${datePart}_${timePart}`;
      }

      // Check if it's the old format with separate date and time (5 parts)
      if (parts.length >= 5) {
        const datePart = parts[3]; // YYYYMMDD
        const timePart = parts[4].replace(".csv", ""); // hhmm (remove .csv extension)

        // Validate that datePart is 8 digits and timePart is 4 digits
        if (/^\d{8}$/.test(datePart) && /^\d{4}/.test(timePart)) {
          return `${datePart}_${timePart}`;
        }
      }
    }

    return "--";
  } catch (error) {
    console.error("Error extracting batch from filename:", error);
    return "--";
  }
};
